import React from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';

const TextFieldsExtra = ({ errorMessage, maxSize, valueSize }) => {
  return (
    <div className={styles.root}>
      {errorMessage && (
        <Typography.Text type="danger" className={styles.error}>
          {errorMessage}
        </Typography.Text>
      )}
      <Typography.Text
        className={styles.counter}
        type={Boolean(errorMessage) ? 'danger' : undefined}
      >
        {valueSize}/{maxSize}
      </Typography.Text>
    </div>
  );
};

export default TextFieldsExtra;
